import React from 'react';
import { MenuGroup, Section } from '@atlaskit/menu';
import { BoardConnectMenuItems } from '@atlassian/jira-software-connect-toolbar';
import { useBacklogSelector } from '../../../../state';
import { getProjectKey, getRapidViewId } from '../../../../state/selectors/app';
import ConfigureBoardItem from '../configure-board-item';
import { CreateBoardMenuItem } from '../create-board';
import ManageCustomFiltersItem from '../manage-custom-filters-item';
import type { Props, MenuItemProps } from '../types';

export type MenuContentProps = Props & MenuItemProps;

const BacklogMenuContent = ({
	isCompanyManaged,
	canEditBoardConfig,
	onClosePopup,
}: MenuContentProps) => {
	const boardId = useBacklogSelector(getRapidViewId);
	const projectKey = useBacklogSelector(getProjectKey);

	return (
		<MenuGroup>
			<Section>
				{isCompanyManaged ? (
					<>
						<ConfigureBoardItem />

						<BoardConnectMenuItems
							boardId={boardId}
							projectKey={projectKey}
							location="board-tools-1"
							mode="plan"
						/>

						{canEditBoardConfig && <CreateBoardMenuItem onClosePopup={onClosePopup} />}

						<BoardConnectMenuItems
							boardId={boardId}
							projectKey={projectKey}
							location="view-actions-print"
							mode="plan"
						/>
					</>
				) : (
					<ManageCustomFiltersItem isDisabled={!canEditBoardConfig} />
				)}
			</Section>
		</MenuGroup>
	);
};

export default BacklogMenuContent;
